import React from 'react';
import { Grid, Link, useMediaQuery, styled as muistyled } from '@mui/material';
import theme from '../../theme';
import { useLocation } from 'react-router-dom';
import { Colors } from 'library';

const Text = muistyled(Link)({
    color: Colors.turquoise,
});

const BrowserBar = muistyled('div')({
    position: 'fixed',
    height: 0,
    bottom: 23,
    right: 0,
});

const PublicFooter = () => {
    const pathname = useLocation().pathname;

    const wouldBeHiddenByMobileNav = useMediaQuery(theme.breakpoints.down('md'));
    const onMessagePage = pathname.includes('messages');

    return wouldBeHiddenByMobileNav || onMessagePage ? null : (
        <BrowserBar>
            <Grid container justifyContent="flex-end">
                <Text href="/" variant="subtitle2">
                    © {new Date().getFullYear()} Tandem, Inc.
                </Text>
            </Grid>
        </BrowserBar>
    );
};

export default PublicFooter;
